import React from 'react';

export const HighLight = ({ children }) => { return <span className='w700'>{children}</span> }
export const Italic = ({ children }) => { return <span className='italic'>{children}</span> }